import { useRef } from 'react';

import { ValueFormatterParams, ValueGetterParams } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import Header from '../../common/Header/Header';
import {
  Page,
  TableWrapper,
} from '../../common/TableWithButtonsRightLayout/TableWithButtonsRightLayout.styles';
import Table from '../../components/Table/Table';

import { useFetchErrorToast } from '../../utils/useFetchErrorToasts/useFetchErrorToast';
import { useOccasions } from '../../services/occasion/occasion.service';
import { readOnlyLabelTableText } from '../../constants/GlobalTexts';

const Occasions = () => {
  const gridRef = useRef<AgGridReact>(null);
  const { data, isError: occasionsError } = useOccasions(true);

  useFetchErrorToast([{ isError: occasionsError, label: 'Error fetching occasions', id: 'occasionsFetchError' }]);

  const occasionValueFormatter = (params: ValueFormatterParams): string => {
    return params.value === false ? 'N' : 'Y';
  };

  const occasionFilterValueGetter = (params: ValueGetterParams): string => {
    return params.getValue(params.column.getColId()) === false ? 'N' : 'Y';
  };

  return (
    <>
      <Header breadcrumb={{ to: '/tables', label: 'All tables' }} title="Occasion" titleTestId={"OccasionPageTitle"} />
      <Page>
        <TableWrapper>
          <Table
            rowData={data?.data}
            ref={gridRef}
            returnedRecords={data?.data?.length}
            height={'100%'}
            readOnlyLabel={readOnlyLabelTableText}
            columnDefs={[
              { minWidth: 112, field: 'occasionNo', headerName: 'Occasion No.' },
              { minWidth: 80, field: 'statusNo', headerName: 'Status No.' },
              { minWidth: 160, field: 'description', headerName: 'Description' },
              {
                minWidth: 80,
                field: 'dineIn',
                headerName: 'Dine In',
                valueFormatter: occasionValueFormatter,
                filterValueGetter: occasionFilterValueGetter
              },
              {
                minWidth: 80,
                field: 'delivery',
                headerName: 'Delivery',
                valueFormatter: occasionValueFormatter,
                filterValueGetter: occasionFilterValueGetter
              },
              {
                minWidth: 80,
                field: 'carryout',
                headerName: 'Carryout',
                valueFormatter: occasionValueFormatter,
                filterValueGetter: occasionFilterValueGetter
              },
              {
                minWidth: 80,
                field: 'counter',
                headerName: 'Counter',
                valueFormatter: occasionValueFormatter,
                filterValueGetter: occasionFilterValueGetter
              },
              {
                minWidth: 80,
                field: 'driveThru',
                headerName: 'Drive thru',
                valueFormatter: occasionValueFormatter,
                filterValueGetter: occasionFilterValueGetter
              },
              {
                minWidth: 80,
                field: 'offPremise',
                headerName: 'Off Premise',
                valueFormatter: occasionValueFormatter,
                filterValueGetter: occasionFilterValueGetter
              },
              {
                minWidth: 80,
                field: 'school',
                headerName: 'School',
                valueFormatter: occasionValueFormatter,
                filterValueGetter: occasionFilterValueGetter
              },
              {
                minWidth: 140,
                field: 'windowSeating',
                headerName: 'Window Seating',
                valueFormatter: occasionValueFormatter,
                filterValueGetter: occasionFilterValueGetter
              },
              {
                minWidth: 80,
                field: 'web',
                headerName: 'Web',
                valueFormatter: occasionValueFormatter,
                filterValueGetter: occasionFilterValueGetter
              },
              {
                minWidth: 80,
                field: 'vcc',
                headerName: 'Vcc',
                valueFormatter: occasionValueFormatter,
                filterValueGetter: occasionFilterValueGetter
              },
              {
                minWidth: 80,
                field: 'overflow',
                headerName: 'Overflow',
                valueFormatter: occasionValueFormatter,
                filterValueGetter: occasionFilterValueGetter
              },
            ]}
          />
        </TableWrapper>
      </Page>
    </>
  );
};

export default Occasions;
